import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import axios from 'axios';
import { _axios } from '../../../utils/axios'; 
import { useNavigate } from 'react-router-dom';
import { ServerPath } from '../../../Constant'
// import {uploadImage} from "../../../Services/azure-storage-blob";
import {uploadImage} from '../../../Services/r2-storage-blob.js';


const AddTag = () => {
    const [show, setShow] = useState(false);
    const [tagName, setTagName] = useState('');
    const [file, setFile] = useState(null);
    const navigate = useNavigate();


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        let imageUrl = '';
        if (file) {
            const filename = `tag_${Date.now()}`;
            imageUrl = await uploadImage(file, filename, 'tags', 'images');
        }

        const newTag = {
            tag_name: tagName,
            status: 1,
            image: imageUrl,
        };

        try {
            const response = await _axios.post(`${ServerPath}/tag/create`, newTag);
            console.log(response.data);
            handleClose();
            window.location.reload();

            // navigate(0);
        } catch (error) {
            console.error(error);
            // Handle any errors here, e.g., show an error message to the user
        }
    };


    // const handleSubmit = async (event) => {
    //     event.preventDefault();

    //     const newTag = {
    //         tag_name: tagName,
    //         status: 1,
    //     };

    //     try {
    //         const response = await axios.post(`${ServerPath}/tag/create`, newTag);

    //         // Assuming the API returns the added tag data, you can update the UI here if needed
    //         console.log(response.data);

    //         // Close the modal
    //         handleClose();
    //         navigate(0);

    //     } catch (error) {
    //         console.error(error);
    //         // Handle any errors here, e.g., show an error message to the user
    //     }
    // };

    return (
        <>
            <button onClick={handleShow} className='btn btn-primary float-end'>Create Tag</button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Tag</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} controlId='formGridTagName'>
                                <Form.Label>Tag Name</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder='Tag Name'
                                    value={tagName}
                                    onChange={(e) => setTagName(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mt-3">
                            <Form.Group as={Col} controlId='formGridImage'>
                                <Form.Label>Tag Image</Form.Label>
                                <Form.Control
                                    type='file'
                                    onChange={handleFileChange}
                                />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button form='AddTagForm' variant="primary" type='submit' onClick={handleSubmit}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddTag;
